import React from "react";
import ProgressiveImage from "react-progressive-image-loading";


const Head = ({title, history}) => {
    /* const hsitoryList = history ? history.map((h, index) => {
        return (
            <span key={index} className="mr-2"><a href={h.to}>{h.page}</a></span>
        )
    }) : null; */

    return (
        <div className="hero-wrap head-section overflow-hidden rou">
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="head-section-img shadow-4d rounded-corners">
                            <ProgressiveImage
                                preview="/images/about_us.png"
                                src="/images/about_us.png"
                                render={(src, style) => <img alt="head" src={src} style={style}/>}
                            />

                            {/*  <div className="overlay"></div>*/}

                            {/*<div className="absolute head-section-content full-width">
                        <div className="container">
                            <div className="row no-gutters slider-text align-items-center justify-content-center"
                                 data-scrollax-parent="true">
                                <div className="col-md-8 ftco-animate">
                                    <div className="breadcrumbs text-center ">
                                        {hsitoryList}
                                    </div>
                                    <h1 className="mb-4 text-center">{title}</h1>
                                </div>
                            </div>
                        </div>
                    </div>*/}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};


export default Head;
